import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

type AlertTone = 'info' | 'warning' | 'danger' | 'success';

const TONE: Record<AlertTone, string> = {
  info: 'border-info/30 bg-info/10 text-info-text',
  warning: 'border-warning/30 bg-warning/10 text-warning-text',
  danger: 'border-destructive/30 bg-destructive/10 text-destructive-text',
  success: 'border-success/30 bg-success/10 text-success-text',
};

interface AlertBannerProps {
  tone?: AlertTone;
  icon?: LucideIcon;
  children: ReactNode;
  className?: string;
}

/** Compact inline banner for page-level notices (test mode, warnings, etc.). */
export function AlertBanner({ tone = 'info', icon: Icon, children, className }: AlertBannerProps) {
  return (
    <div
      role="status"
      className={cn(
        'mb-4 flex items-start gap-2 rounded-lg border px-4 py-3 text-sm',
        TONE[tone],
        className,
      )}
    >
      {Icon && <Icon className="mt-0.5 h-4 w-4 shrink-0" />}
      <div className="min-w-0 flex-1">{children}</div>
    </div>
  );
}
